// extracted by mini-css-extract-plugin
export default {"modelMail":"styles_modelMail__JD4CH","buttonSection":"styles_buttonSection__RnuF1","button":"styles_button__5blNH","button1":"styles_button1__QIg9R"};